import { trigger, state, style, transition, animate } from "@angular/animations";
import {
	Component,
	Input,
	ViewEncapsulation,
	Output,
	EventEmitter,
	Host,
	Optional,
	OnDestroy
} from "@angular/core";
import { IdService } from "../shared/services/id.service";

@Component({
	selector: "rbc-expandable",
	templateUrl: "./expandable.component.html",
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger("height", [
			// state("true", style({
			// 	height: "*",
			// })),
			// state("false", style({
			// 	height: "0px",
			// 	"visibility": "hidden",
			// 	overflow: "hidden"
			// })),
			// state("void", style({
			// 	height: "*",
			// 	overflow: "hidden"
			// })),
			// transition("true => false", animate("400ms ease-in-out")),
			// transition("false => true", animate("400ms ease-in-out"))
			transition(":enter", [
				style({ 
					height: 0, 
					overflow: "hidden" 
				}),
				animate("0.4s ease-in-out", 
					style({
						height: "*" 
					})
				)
			]),
			transition(":leave", [
				style({ 
					overflow: "hidden" 
				}),
				animate("0.4s ease-in-out", 
					style({ 
						overflow: "hidden", 
						height: 0 
					})
				)
			])
		]),
	],
})
export class ExpandableComponent implements OnDestroy {
	@Input() id: string;
	@Input() expanded = false;
	@Input() arrow = false;
	@Input() arrowPositionX: "left" | "center" | "right" = "right";
	@Input() arrowPositionY: "top" | "middle" | "bottom" = "top";
	@Input() duration: number;
	@Input() toggleShow = false;
	@Input() hostClass: string | string[];
	@Input() childId: string;
	@Input() disabled: boolean;

	// Output Parameters
	@Output() expandclose = new EventEmitter();
	@Output() expandopen = new EventEmitter();

	constructor(
		private idService: IdService
	) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	toggle() {
		this.expanded = !this.expanded;

		if (this.expanded) {
			this.expandopen.emit(this.id);
		} else {
			this.expandclose.emit(this.id);
		}
	}
}
